function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8C0 7.44772 0.447715 7 1 7H47C47.5523 7 48 7.44772 48 8C48 8.55228 47.5523 9 47 9H0.999999C0.447714 9 0 8.55228 0 8Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.334,
  y: 14.3333,
  width: 36,
  height: 2,
  rx: 1,
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118 45.875C118 45.3918 118.392 45 118.875 45H165.125C165.608 45 166 45.3918 166 45.875C166 46.3582 165.608 46.75 165.125 46.75H118.875C118.392 46.75 118 46.3582 118 45.875Z",
  fill: "#EAEEF4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113 51.125C113 50.6418 113.392 50.25 113.875 50.25H142.125C142.608 50.25 143 50.6418 143 51.125C143 51.6082 142.608 52 142.125 52H113.875C113.392 52 113 51.6082 113 51.125Z",
  fill: "#EAEEF4"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79,
  cy: 87.5,
  rx: 60,
  ry: 9.5,
  fill: "#F5F8FA"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 17,
  r: 17,
  fill: "#EAEEF4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.5,
  cy: 35.5,
  r: 11.5,
  fill: "#EAEEF4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M54.8105 21.1063C53.7298 22.2185 53.7298 24.015 54.8105 25.1271L60.4353 30.916L60.1028 31.2867V62.6261C60.1028 65.7629 62.5966 68.3294 65.6445 68.3294H93.353C94.3228 68.3294 95.2372 68.0442 96.0407 67.5879L99.2826 70.9244C100.363 72.0365 102.109 72.0365 103.19 70.9244C104.27 69.8122 104.27 68.0157 103.19 66.9036L58.7174 21.1063C57.6367 19.9942 55.8911 19.9942 54.8105 21.1063ZM98.8947 54.3849V22.7033C98.8947 19.5665 96.4009 17 93.353 17H73.9848L68.2768 22.8744L98.8947 54.3849Z",
  fill: "url(#paint0_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 65,
  y: 55.8276,
  width: 3,
  height: 6.96926,
  rx: 1.5,
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 77,
  y: 55.8276,
  width: 3,
  height: 6.96926,
  rx: 1.5,
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 71,
  y: 55.8276,
  width: 3,
  height: 6.96926,
  rx: 1.5,
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 83,
  y: 55.8276,
  width: 3,
  height: 6.96926,
  rx: 1.5,
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 29,
  y1: 44.3792,
  x2: 83.533,
  y2: 94.1733,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgCrossedStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 97,
    viewBox: "0 0 166 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = React.forwardRef(SvgCrossedStorage);
export default __webpack_public_path__ + "static/media/crossed-storage.dd98fd02.svg";
export { ForwardRef as ReactComponent };